import { render, staticRenderFns } from "./ReiseUebersicht.vue?vue&type=template&id=5f1ae74b&scoped=true"
import script from "./ReiseUebersicht.vue?vue&type=script&lang=ts"
export * from "./ReiseUebersicht.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ae74b",
  null
  
)

export default component.exports